export function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: '제품 검색 및 비교',
      description: '필요한 어구, 갑판용품, 기관물품을 검색하고 전국 제조업체의 제품을 한눈에 비교하세요. 지역, 가격, 품질 등 다양한 조건으로 필터링할 수 있습니다.',
      icon: 'ri-search-2-line',
      color: 'bg-ocean-500',
    },
    {
      number: '02',
      title: '제조업체 확인',
      description: '제조업체의 상세 정보, 인증서, 실제 사용 후기를 확인하세요. 부산, 보령, 목포 등 전국 각지의 검증된 업체 정보를 투명하게 제공합니다.',
      icon: 'ri-building-line',
      color: 'bg-marine-500',
    },
    {
      number: '03',
      title: '견적 요청 및 상담',
      description: '관심 있는 제품의 견적을 요청하고 제조업체와 직접 소통하세요. 전문가 상담을 통해 최적의 제품을 선택할 수 있습니다.',
      icon: 'ri-chat-quote-line',
      color: 'bg-ocean-600',
    },
    {
      number: '04',
      title: '직거래 및 배송',
      description: '중간 유통 없이 제조업체와 직접 거래하여 합리적인 가격에 구매하세요. 안전한 결제와 신속한 배송으로 빠르게 제품을 받아보실 수 있습니다.',
      icon: 'ri-truck-line',
      color: 'bg-marine-600',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-72 h-72 bg-ocean-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-marine-500 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            이용 프로세스
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            간단한 4단계로 전국의 우수한 제조업체와 직거래를 시작하세요
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-20 left-full w-full h-0.5 bg-gradient-to-r from-ocean-300 to-transparent -translate-x-4 z-0"></div>
              )}

              <div className="relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 h-full">
                <div className="flex items-center justify-between mb-6">
                  <div className={`w-16 h-16 ${step.color} rounded-xl flex items-center justify-center shadow-lg`}>
                    <i className={`${step.icon} text-white text-2xl`}></i>
                  </div>
                  <div className="text-5xl font-bold text-gray-100">{step.number}</div>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-ocean-600 to-marine-600 rounded-2xl p-8 md:p-12 text-center shadow-xl">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
            지금 바로 시작하세요
          </h3>
          <p className="text-ocean-100 mb-8 max-w-2xl mx-auto">
            회원가입 후 즉시 전국의 제조업체와 2,500개 이상의 제품을 만나보실 수 있습니다
          </p>
          <button className="px-8 py-4 bg-white text-ocean-600 font-semibold rounded-lg hover:bg-gray-50 transition-colors shadow-lg whitespace-nowrap cursor-pointer">
            무료로 시작하기
          </button>
        </div>
      </div>
    </section>
  );
}
